namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem6ExemptService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem6Exempt';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem6ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem6ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem6ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem6ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem6Exempt/Create",
            Update = "AdvPromo/PsAdvPromoItem6Exempt/Update",
            Delete = "AdvPromo/PsAdvPromoItem6Exempt/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem6Exempt/Retrieve",
            List = "AdvPromo/PsAdvPromoItem6Exempt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem6ExemptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
